// Toast.js — Notifikasi singkat di bawah layar
// Letakkan di: src/component/khas/Toast.js
import React from 'react'

function Toast({ message }) {
  return (
    <div className={`khas-toast${message ? ' show' : ''}`}>
      {message}
    </div>
  )
}

export default Toast